import React from 'react'
import { Link } from 'gatsby'
import BrocherSidebar from './BrocherSidebar'
import ReactMarkdown from 'react-markdown'

const Brochers = ( {data} ) => {

    return (
    
        <section className=' services-details-area component-parent'>
            <div className='heading-container intro-container container text-center mt-5 mb-4'>
                <h2 className='font-outfit'>{data?.heading}</h2>
                <ReactMarkdown>{data?.whyUsDescription?.data?.whyUsDescription}</ReactMarkdown>
                <img src={data?.image?.url} alt='secure transfusion solutions mb-5' />
                <div className="clientLinks">
                    <ReactMarkdown>
                        {data?.clientDescriptionLinks?.data?.clientDescriptionLinks}
                    </ReactMarkdown>
                </div>
            </div>  
            <div className='container mt-5'>
                <div className="row">
                    {
                       data?.tiles?.map((tile)=>{
                        return(
                            <div className="col-lg-6 col-md-6">
                            <div className="single-industries-serve-box">
                                <div className="icon">
                                    <img src={tile?.icon?.url} alt='icon' />
                                </div>
                                <h3 className='m-0'>{tile?.detail}</h3>
                            </div>
                            </div>
                        )
                       })
                    }
                    
                </div>

                <div className='d-flex justify-content-center' id='Panacea-btn'>
                    <div className="">
                        <Link 
                            to="/history" 
                            activeClassName="active"
                            className="default-btn"
                        >
                            <i className="flaticon-right"></i>Successful Deployments<span></span>
                        </Link>
                    </div>
                    <BrocherSidebar />
                </div>
            </div>
        </section>
    )
}

export default Brochers